import React, { useState } from "react";
import { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl } from "../../context/BaseUrl";

const FeedBack = ({ handle }) => {
  // For Suggestion form

  const { feed, setFeed } = handle;

  // const [subject, setSubject] = useState("");
  // const [message, setMessage] = useState("");
  const [institutes, setInstitutes] = useState(false);
  const [institutesId, setInstitutesID] = useState(false);
  // const [file, setFile] = useState("");

  // const handleSent = async () => {
  //   const response = await fetch(`${baseUrl}/user/feedback/postfeedback`, {
  //     method: "post",
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       subject,
  //       message,
  //       file,
  //     }),
  //   });

  //   const result = await response.json();

  //   if (result.code == 500) {
  //     toast.error(result.msg);
  //     return;
  //   }

  //   toast.success(result.msg);
  //   setSubject("");
  //   setMessage("");
  //   setFile("");
  //   setFeed(false);
  // };

  const fetchData = async () => {
    const response = await fetch(`${baseUrl}/user/institute/getallinstitute`, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();

    if (result.code == 500) {
      toast.error(result.msg);
      return;
    }
    setInstitutes(() => {
      return result.map((el) => {
        return { name: el.name, _id: el.institute_id };
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Modal show={feed} onHide={() => setFeed(false)} className="suggestion-box">
      <ToastContainer />
      <Modal.Header closeButton>
        <Modal.Title>Feedback Box</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-4" controlId="FormInput">
            <Form.Select onChange={(e) => setInstitutesID(e.target.value)}>
              <option value="" disabled selected>
                Select Institute
              </option>

              {institutes &&
                institutes.map((el, index) => (
                  <option key={index} value={el._id}>{el.name}</option>
                ))}
            </Form.Select>
          </Form.Group>

          {/*<Form.Group className="mb-4" controlId="FormTextarea">
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Type Message"
              onChange={(e) => setMessage(e.target.value)}
              value={message}
            />
  </Form.Group>*/}
          {/*<Form.Group className="mb-4" controlId="FormInput">
            <Form.Control type="file" value={file} />
</Form.Group>*/}
        </Form>

        <Link to={institutesId ? `/institute/${institutesId}` : "#"}>
          <Button variant="primary">Give Feedback</Button>
        </Link>
      </Modal.Body>
    </Modal>
  );
};

export default FeedBack;
